import React from "react";
import {Switch, Route} from "Core/router";
import {AppPageRoute} from "Core/App";

// Import section pages
import * as defaultApp from "./default"

const AppsSection = () => (
	<div id="apps-section">
		<Switch>
			<Route>
				<AppPageRoute page={defaultApp} />
			</Route>
		</Switch>
	</div>
);

export default AppsSection;